'use client'
import React from 'react'
import styled from 'styled-components'
import dynamic from 'next/dynamic'

// Elements
import WidthContainer from '../../elements/widthContainer'
import ButtonElement from '../../elements/buttons'
// Compositions
import InfoLinkList from '../../compositions/infoLinksList'
import { SectionElement } from '../../compositions/articleSection'
// Modules
import ArticleImages from '../../modules/_subsite/articleImages'
import ContactBlock from '../../modules/_subsite/contactBlock'
import FacilityPrices from '../../modules/_subsite/facilityPrices'
// Sections
import AllFacilities from '../allFacilities'
import MainInfo from '../mainPageInfo'
import Tables from '../tabels'
import SubsiteNewsSection from '../newsSection'
import ArticleRichText from '../articleRichText'
import SubsiteShortNewsSection from '../shortNewsSection'
import Rates from '../rates'
import EventCalendarHome from '@/core/sections/eventsCalendarHome'
// Other
import { blue, subsite_hover_blue } from '../../colors'

// Dynamically import since window is required
const DynamicShare = dynamic(() => import('../../modules/_subsite/share'), {
  ssr: false,
})

const Wrapper = styled.div`
  display: block;
  flex-direction: row;
  .intro {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 440px);
    margin-right: 30px;
    .imagesContainer {
      width: calc(100% + 440px) !important;
      span {
        overflow: visible !important;
        img {
          overflow: visible;
          object-fit: cover;
        }
      }
    }

    @media screen and (max-width: 1300px) {
      width: 100%;
      padding: 0;
      margin-top: 10px;
    }
    @media screen and (max-width: 700px) {
      margin-top: 60px;
    }
  }
  .side {
    display: inline-block;
    vertical-align: top;
    width: 410px;
    .button {
      margin-bottom: 46px;
      ${(props) =>
        props.useBlueButton &&
        `
                a {
                    background-color: ${blue};
                    :hover {
                        background-color: ${subsite_hover_blue};
                    }
                }
            `}

      @media screen and (max-width: 600px) {
        svg {
          display: none;
        }
      }
    }
    > div {
      margin-bottom: 24px;
    }

    @media screen and (max-width: 1300px) {
      width: 100%;
      padding: 0;
      margin-top: 40px;
    }
  }
`

const mapElements = {
  images: ArticleImages,
  facilities: AllFacilities,
  openingtimes: MainInfo,
  news: SubsiteNewsSection,
  events: EventCalendarHome,
  prices: FacilityPrices,
  text: ArticleRichText,
  facilityprices: FacilityPrices,
  tables: Tables,
  shortnews: SubsiteShortNewsSection,
  contact: ContactBlock,
  share: DynamicShare,
  section: SectionElement,
  rates: Rates,
}

const ArticleIntroSmall = ({ intro, link, lists, useBlueButton = false }) => {
  return (
    <WidthContainer variant="semi">
      <Wrapper useBlueButton={useBlueButton}>
        <div className="intro">
          {intro?.map((item, i) => {
            if (!(item?.type in mapElements)) return null
            const Section = mapElements[item.type]
            return <Section {...item.value} key={`intro-section-${i}`} />
          })}
        </div>
        <div className="side">
          {link && (
            <div className="button">
              <ButtonElement
                variant="primaryLink"
                href={link.href || link.external_url}
              >
                {link.text}
              </ButtonElement>
            </div>
          )}

          {lists &&
            lists?.map((list, i) => {
              return (
                <InfoLinkList {...list} key={`list-item-${i}-${list.title}`} />
              )
            })}
        </div>
      </Wrapper>
    </WidthContainer>
  )
}

export default ArticleIntroSmall
